// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAllowInvestmentsPropertyDto
 */
export interface IAllowInvestmentsPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IAllowInvestmentsPropertyDto
     */
    allow_investments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAllowInvestmentsPropertyDto
     */
    allow_investments_state?: IAllowInvestmentsPropertyDtoAllowInvestmentsStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAllowInvestmentsPropertyDtoAllowInvestmentsStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAllowInvestmentsPropertyDto interface.
 */
export function instanceOfIAllowInvestmentsPropertyDto(value: object): value is IAllowInvestmentsPropertyDto {
    return true;
}

export function IAllowInvestmentsPropertyDtoFromJSON(json: any): IAllowInvestmentsPropertyDto {
    return IAllowInvestmentsPropertyDtoFromJSONTyped(json, false);
}

export function IAllowInvestmentsPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowInvestmentsPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allow_investments': json['allow_investments'] == null ? undefined : json['allow_investments'],
        'allow_investments_state': json['allow_investments_state'] == null ? undefined : json['allow_investments_state'],
    };
}

export function IAllowInvestmentsPropertyDtoToJSON(json: any): IAllowInvestmentsPropertyDto {
    return IAllowInvestmentsPropertyDtoToJSONTyped(json, false);
}

export function IAllowInvestmentsPropertyDtoToJSONTyped(value?: IAllowInvestmentsPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allow_investments': value['allow_investments'],
        'allow_investments_state': value['allow_investments_state'],
    };
}

